import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getFeedbackById = createAsyncThunk(
  "feedback/getFeedbackById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.get(`feedback/${id}`);
      return response.data;
    } catch (err) {
      if (!err.response) throw err;
      return rejectWithValue(err.response.data);
    }
  }
);

const FeedbackDetailsSlice = createSlice({
  name: "FeedbackDetailsSlice",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
  reducers: {
    resetFeedbackDetails: (state) => {
      state.isLoading = false;
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeedbackById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFeedbackById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data;
      })
      .addCase(getFeedbackById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { resetFeedbackDetails } = FeedbackDetailsSlice.actions;
export default FeedbackDetailsSlice.reducer;
